/** Bulk edit — datatable card inside General list shell (same pattern as products list). */

export const bulkEditCard =
  'crm-bulk-edit-card flex min-h-0 flex-1 flex-col overflow-hidden rounded-lg border border-border bg-card';

export const bulkEditCardBody = 'crm-bulk-edit-card__body flex min-h-0 flex-1 flex-col overflow-hidden';

export const bulkEditCardFooter = 'crm-bulk-edit-card__footer shrink-0';

export const bulkEditTableScroll =
  'crm-bulk-edit-scroll min-h-0 flex-1 overflow-auto bg-card';

export const bulkEditCheckbox = 'size-4 rounded-[4px]';

export const bulkEditSelectTrigger = 'crm-bulk-edit-select';
